module.exports = __webpack_public_path__ + "media/images/WalletConnet-33e41e4b.svg";